/**
 * All possible chunk types in CranqLang
 */
export enum ChunkType {
  // Full-String
  About = "About",
  ChildNode = "ChildNode",
  ChildNodes = "ChildNodes",
  ChildNodesItem = "ChildNodesItem",
  Comment = "Comment",
  Connection = "Connection",
  Connections = "Connections",
  ConnectionsItem = "ConnectionsItem",
  Dependencies = "Dependencies",
  DependenciesItem = "DependenciesItem",
  Dependency = "Dependency",
  Include = "Include",
  Node = "Node",
  NodeCode = "NodeCode",
  NodeImpl = "NodeImpl",
  NodeParam = "NodeParam",
  NodeParams = "NodeParams",
  NodeParamsItem = "NodeParamsItem",
  Port = "Port",
  PortDomain = "PortDomain",
  PortExposure = "PortExposure",
  PortExposures = "PortExposures",
  PortExposuresItem = "PortExposuresItem",
  Ports = "Ports",
  PortsItem = "PortsItem",
  Script = "Script",
  Type = "Type",

  // Includes
  Any = "Any",
  BuiltinCode = "BuiltinCode",
  BuiltinTarget = "BuiltinTarget",
  BuiltinType = "BuiltinType",
  ChildPort = "ChildPort",
  ChildPortDirection = "ChildPortDirection",
  ConnectionBody = "ConnectionBody",
  Export = "Export",
  Identifier = "Identifier",
  NodeDecl = "NodeDecl",
  PortDecl = "PortDecl",
  PortDirection = "PortDirection",
  PortExposureBody = "PortExposureBody",
  PortsDirection = "PortsDirection",
  Runtime = "Runtime",
  SpreadOp = "SpreadOp",
  String = "String",
  VarAssignment = "VarAssignment",
  VarDecl = "VarDecl"
}
